<template>
  <div class="item bo_soldout-item-row">
    <div class="item-col-left">
      <img v-if="item.imageUrl" :src="item.imageUrl" width="100" height="100"/>
      <span v-else class="bo_item-image-placeholder"><font-awesome-icon :icon="['fas', 'utensils']"/></span>
    </div>
    <div class="item-col-right">
      <!-- Item without variants: clicking the row marks the whole product sold out (unless already sold out) -->
      <div v-if="!hasSubselections" class="flex-box" :class="{ 'bo_clickable-row': !itemAlreadySoldOut }" @click="!itemAlreadySoldOut && $emit('toggleItem', item)">
        <div>
          <span class="item-title">{{ item.menuNr }} &nbsp;&nbsp;  {{ item.name }} </span>
          <div v-if="item.description" class="description">{{ item.description }}</div>
        </div>
        <div class="cart-buttons-panel">
          <span v-if="itemAlreadySoldOut" class="bo_sold-out-badge">Utsolgt</span>
          <input v-else type="checkbox" :checked="itemSelected" class="multiple-checkbox bo_checkbox-display" />
        </div>
      </div>

      <!-- Item with variants: the item row checks/unchecks all variants, each variant row marks just that variant -->
      <div v-else class="w-100">
        <div class="flex-box" :class="{ 'bo_clickable-row': !masterAllSoldOut }" @click="!masterAllSoldOut && $emit('toggleAllSubselections', item)">
          <div class="item-title">{{ item.menuNr }} &nbsp;&nbsp;  {{ item.name }}</div>
          <div class="cart-buttons-panel">
            <span v-if="masterAllSoldOut" class="bo_sold-out-badge">Utsolgt</span>
            <input v-else type="checkbox" :checked="allSubselectionsSelected" :indeterminate.prop="someSubselectionsSelected && !allSubselectionsSelected" class="multiple-checkbox bo_checkbox-display" />
          </div>
        </div>
        <div v-for="subselection in item.subselections" :key="subselection.id" class="flex-box my-3" :class="{ 'bo_clickable-row': !subselectionAlreadySoldOut(subselection) }" @click="!subselectionAlreadySoldOut(subselection) && $emit('toggleSubselection', subselection)">
          <div class="ms-2">{{ subselection.name }}</div>
          <div class="cart-buttons-panel">
            <span v-if="subselectionAlreadySoldOut(subselection)" class="bo_sold-out-badge">Utsolgt</span>
            <input v-else type="checkbox" :checked="isSubselectionSelected(subselection)" class="multiple-checkbox bo_checkbox-display" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: { type: Object, required: true },
    selectedItems: { type: Array, default: () => [] },
    selectedSubselections: { type: Array, default: () => [] },
    soldOutItemIds: { type: Array, default: () => [] }, //Items already marked sold out
    soldOutSubselectionIds: { type: Array, default: () => [] } //Variants already marked sold out
  },
  emits: ['toggleItem', 'toggleSubselection', 'toggleAllSubselections'],
  computed: {
    hasSubselections(){
      return this.item.subselections && this.item.subselections.length > 0;
    },
    itemSelected(){
      return this.selectedItems.some(selected => selected.id === this.item.id);
    },
    itemAlreadySoldOut(){
      return this.soldOutItemIds.includes(this.item.id);
    },
    selectableSubselections(){
      //Variants that are not already sold out (so they can still be marked)
      if(!this.hasSubselections){
        return [];
      }
      return this.item.subselections.filter(subselection => !this.subselectionAlreadySoldOut(subselection));
    },
    masterAllSoldOut(){
      //Every variant is already sold out, nothing left to mark from the item row
      return this.hasSubselections && this.selectableSubselections.length === 0;
    },
    allSubselectionsSelected(){
      return this.selectableSubselections.length > 0 && this.selectableSubselections.every(subselection => this.isSubselectionSelected(subselection));
    },
    someSubselectionsSelected(){
      return this.selectableSubselections.some(subselection => this.isSubselectionSelected(subselection));
    }
  },
  methods: {
    isSubselectionSelected(subselection){
      return this.selectedSubselections.some(selected => selected.id === subselection.id);
    },
    subselectionAlreadySoldOut(subselection){
      return this.soldOutSubselectionIds.includes(subselection.id);
    }
  }
}
</script>

<style scoped>
/* Stretch the columns to the full row height, then center the content within each column */
.item{
  align-items: stretch;
}
.bo_soldout-item-row{
  padding-top: 15px;
  padding-bottom: 15px;
  padding-right: 5px;
}
.item-col-left{
  float: none; /* float collapses the column height, leaving the image off-center */
  display: flex;
  align-items: center;
  justify-content: center;
  /* The global [class*="col-"] rule adds padding-bottom: 15px to these columns (their names contain "col-"), pushing content up */
  padding-top: 0;
  padding-bottom: 0;
}
.item-col-left img{
  display: block; /* Removes the inline descender gap below the image */
}
.item-col-right{
  align-items: center;
  padding-top: 0;
  padding-bottom: 0;
}
.cart-buttons-panel{
  align-items: center;
}
/* .bo_clickable-row / .bo_checkbox-display now live in backoffice.css — shared with the discount picker */
</style>
